export default {"src":"/_next/static/media/billing.06e1de54.svg","height":476,"width":736};